import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";

import { Link as RouterLink } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import SubmitButton from "@covertree/ui/buttons/SubmitButton";
import Form from "@covertree/ui/forms/Form";
import FormPhoneField from "@covertree/ui/forms/FormPhoneField";
import FormTextField from "@covertree/ui/forms/FormTextField";

import {
  defaultValues,
  createValidationSchema,
  type LoginFormData,
} from "./form";
import type { UsernameType } from "../types";

interface Props {
  submit: (values: LoginFormData) => void;
  usernameType: UsernameType;
  forgotPasswordPath?: string;
}

export const LoginForm = ({
  submit,
  forgotPasswordPath,
  usernameType,
}: Props) => {
  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues,
    mode: "all",
    resolver: yupResolver(createValidationSchema(usernameType)),
  });

  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Grid container>
        <Grid item xs={12}>
          {usernameType === "email" ? (
            <FormTextField
              id="username-field"
              name="username"
              label="Email"
              control={control}
              disabled={isSubmitting}
            />
          ) : (
            <FormPhoneField
              id="username-field"
              name="username"
              label="Phone number"
              control={control}
              disabled={isSubmitting}
            />
          )}
        </Grid>
        {usernameType === "email" ? (
          <Grid item xs={12}>
            <FormTextField
              id="password-field"
              name="password"
              label="Password"
              type="password"
              control={control}
              disabled={isSubmitting}
            />
          </Grid>
        ) : null}
        {forgotPasswordPath ? (
          <Box mt={1}>
            <Link
              component={RouterLink}
              to={`../${forgotPasswordPath}`}
              underline="hover">
              Forgot password?
            </Link>
          </Box>
        ) : null}
        <SubmitButton
          loading={isSubmitting}
          disabled={!isValid || isSubmitting}>
          Log In
        </SubmitButton>
      </Grid>
    </Form>
  );
};

export default LoginForm;
